import type { TFunction } from 'i18next'

export const initialFilterSelect = {
  total_spent: 100,
  tipped: 10,
  subscribed: 1,
  inactive: 1
}

export const getFansCustomGroupSortOptions = (t: TFunction) => [
  { value: 'expiring', name: t('expiring') },
  { value: 'total_spent', name: t('totalSpent') },
  { value: 'last_activity', name: t('lastActivity') },
  { value: 'name', name: t('name') },
  { value: 'join_date', name: t('joinDate') },
  {
    value: 'total_months_subscribed',
    name: t('totalMonthsSubscribed')
  },
  {
    value: 'upsell_conversion_ratio',
    name: t('upsellConversionRatio')
  }
]

export const getFansCustomGroupSortOrderOptions = (t: TFunction) => [
  { value: 'asc', name: t('ascending') },
  { value: 'desc', name: t('descending') }
]

export const getFansCustomGroupFilterOptions = (t: TFunction) => [
  {
    value: 'total_spent',
    name: t('totalSpent'),
    selectOptions: [
      { value: 100, label: '$100+' },
      { value: 200, label: '$200+' },
      { value: 300, label: '$300+' },
      { value: 400, label: '$400+' },
      { value: 500, label: '$500+' },
      { value: 600, label: '$600+' },
      { value: 700, label: '$700+' },
      { value: 800, label: '$800+' },
      { value: 900, label: '$900+' },
      { value: 1000, label: '$1000+' }
    ]
  },
  {
    value: 'tipped',
    name: t('tipped'),
    selectOptions: [
      { value: 10, label: '$10+' },
      { value: 20, label: '$20+' },
      { value: 30, label: '$30+' },
      { value: 40, label: '$40+' },
      { value: 50, label: '$50+' },
      { value: 60, label: '$60+' },
      { value: 70, label: '$70+' },
      { value: 80, label: '$80+' },
      { value: 90, label: '$90+' },
      { value: 100, label: '$100+' },
      { value: 110, label: '$110+' },
      { value: 120, label: '$120+' },
      { value: 130, label: '$130+' },
      { value: 140, label: '$140+' },
      { value: 150, label: '$150+' },
      { value: 160, label: '$160+' },
      { value: 170, label: '$170+' },
      { value: 180, label: '$180+' },
      { value: 190, label: '$190+' },
      { value: 200, label: '$200+' }
    ]
  },
  {
    value: 'subscribed',
    name: t('subscribed'),
    selectOptions: [
      { value: 1, label: '1 month+' },
      { value: 2, label: '2 months+' },
      { value: 3, label: '3 months+' },
      { value: 4, label: '4 months+' },
      { value: 5, label: '5 months+' },
      { value: 6, label: '6 months+' },
      { value: 7, label: '7 months+' },
      { value: 8, label: '8 months+' },
      { value: 9, label: '9 months+' },
      { value: 10, label: '10 months+' },
      { value: 11, label: '11 months+' },
      { value: 12, label: '12 months+' }
    ]
  },
  {
    value: 'inactive',
    name: t('inactive'),
    selectOptions: [
      { value: 1, label: '1 day+' },
      { value: 2, label: '2 days+' },
      { value: 3, label: '3 days+' },
      { value: 4, label: '4 days+' },
      { value: 5, label: '5 days+' },
      { value: 6, label: '6 days+' },
      { value: 7, label: '7 days+' }
    ]
  },
  { value: 'online', name: t('online') },
  { value: 'renew_on', name: t('renewOn') },
  { value: 'renew_off', name: t('renewOff') }
]